"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _HighlightedCardWrapperLabel = _interopRequireDefault(require("../HighlightedCardWrapperLabel"));
var _style = require("../system/style");
var _busbud = _interopRequireDefault(require("../themes/busbud"));
var _utilities = require("../utilities");
var _HighlightedCardWrapper = require("./HighlightedCardWrapper.styles");
const _excluded = ["bgColor", "classes", "children", "color", "component", "slotStart", "slotEnd"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * A wrapper element for displaying an additional content.
 *
 * [Storybook](https://busbud.github.io/design-system/?path=/docs/components-layout-highlightedcardwrapper--page)
 */
const HighlightedCardWrapper = _ref => {
  let {
      bgColor,
      classes: classesOverrides,
      children,
      color = 'neutral',
      component: Component = 'div',
      slotStart,
      slotEnd
    } = _ref,
    other = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const {
    classes,
    cx
  } = (0, _HighlightedCardWrapper.useStyles)({
    classesOverrides
  });
  const mapChildren = children => _react.default.Children.map(children, child => /*#__PURE__*/_react.default.isValidElement(child) && child.type === _HighlightedCardWrapperLabel.default ? /*#__PURE__*/_react.default.cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
    color
  })) : child);

  // TODO: Replace with `getColorValue()` function when it'll be added
  // https://github.com/busbud/design-system/issues/1267
  const bgColorValue = (0, _style.getPath)(_busbud.default, `busbud.colors.${bgColor}`);
  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
    className: cx(classes.root, classes[`color${(0, _utilities.capitalizeFirstWord)(color)}`]),
    style: {
      // If we have `bgColor`, inline style will override `variant` value
      [_HighlightedCardWrapper.BACKGROUND_COLOR_CSS_PROPERTY]: bgColorValue
    }
  }, other), slotStart && /*#__PURE__*/_react.default.createElement("div", null, mapChildren(slotStart)), children && /*#__PURE__*/_react.default.createElement("div", null, children), slotEnd && /*#__PURE__*/_react.default.createElement("div", null, mapChildren(slotEnd)));
};
var _default = exports.default = HighlightedCardWrapper;